export default __webpack_public_path__ + "2e6faf4392bf2334331fd2b612e29075.png";